import React from "react";

const PATHS = {
  pin: <><path d="M12 21s7-5.7 7-11a7 7 0 1 0-14 0c0 5.3 7 11 7 11z"/><circle cx="12" cy="10" r="2.5"/></>,
  cal: <><rect x="3" y="4.5" width="18" height="17" rx="2"/><path d="M3 9h18M8 2.5v4M16 2.5v4"/></>,
  clock: <><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></>,
  users: <><circle cx="9" cy="8" r="3.4"/><path d="M2.5 20a6.5 6.5 0 0 1 13 0"/><path d="M16 5.5a3.4 3.4 0 0 1 0 6.6M22 20a6 6 0 0 0-4-5.6"/></>,
  user: <><circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/></>,
  search: <><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/></>,
  dollar: <><path d="M12 2v20M17 6.5C17 4.6 14.8 3.5 12 3.5S7 4.8 7 7s2 3 5 3.5 5 1.5 5 4-2.2 3.5-5 3.5-5-1.1-5-3"/></>,
  star: <><path d="M12 3l2.6 5.6 6 .6-4.5 4 1.3 6L12 16.8 6.6 19.2l1.3-6-4.5-4 6-.6z"/></>,
  check: <><path d="M5 12.5l4.5 4.5L19 7"/></>,
  chevL: <><path d="M15 5l-7 7 7 7"/></>,
  chevR: <><path d="M9 5l7 7-7 7"/></>,
  arrowR: <><path d="M4 12h15M13 5l7 7-7 7"/></>,
  x: <><path d="M6 6l12 12M18 6L6 18"/></>,
  history: <><path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 4v4h4"/><path d="M12 8v4l3 2"/></>,
  info: <><circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 7.5h.01"/></>,
  alert: <><circle cx="12" cy="12" r="9"/><path d="M12 8v4M12 16h.01"/></>,
  shield: <><path d="M12 3l7 3v5c0 4.5-3 7.7-7 9-4-1.3-7-4.5-7-9V6z"/><path d="M9 12l2 2 4-4"/></>,
  phone: <><path d="M5 4h3l1.5 4.5L7.8 10a12 12 0 0 0 6.2 6.2l1.5-1.7L20 16v3a2 2 0 0 1-2.2 2A16 16 0 0 1 4 6.2 2 2 0 0 1 5 4z"/></>,
  mail: <><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 7l9 6 9-6"/></>,
  glass: <><path d="M5 3h14l-2 8a5 5 0 0 1-10 0z"/><path d="M12 16v5M8 21h8"/></>,
  ban: <><circle cx="12" cy="12" r="9"/><path d="M5.6 5.6l12.8 12.8"/></>,
  map: <><path d="M9 4L3 6.5v13L9 17l6 2.5 6-2.5v-13L15 6.5 9 4z"/><path d="M9 4v13M15 6.5v13"/></>,
  ticket: <><path d="M3 8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2 2 2 0 0 0 0 4 2 2 0 0 1-2 2H5a2 2 0 0 1-2-2 2 2 0 0 0 0-4z"/><path d="M14 6v12" strokeDasharray="2 2"/></>,
  spark: <><path d="M12 3l1.8 4.5L18.5 9.3 14 11.2 12 16l-2-4.8L5.5 9.3 10.2 7.5z"/></>,
  plus: <><path d="M12 5v14M5 12h14"/></>,
  filter: <><path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z"/></>,
  ball: <><circle cx="12" cy="12" r="10"/><path d="M6.2 6.2c2.4-2.4 5.8-2.4 8.2 0M6.2 17.8c2.4 2.4 5.8 2.4 8.2 0M6.2 6.2c-2.4 2.4-2.4 5.8 0 8.2M17.8 6.2c2.4 2.4 2.4 5.8 0 8.2"/></>,
  layers: <><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></>,
  building: <><rect x="4" y="2" width="16" height="20" rx="2" ry="2"/><path d="M9 22v-4h6v4M8 6h2M14 6h2M8 10h2M14 10h2M8 14h2M14 14h2"/></>,
  tent: <><path d="M19 22L12 5 5 22M12 5v17M12 15l-4 7M12 15l4 7M5 22h14"/></>,
  court: <><rect x="2" y="4" width="20" height="16" rx="2" /><line x1="12" y1="4" x2="12" y2="20" /><circle cx="12" cy="12" r="3.5" /><path d="M2 9h3v6H2M22 9h-3v6h3" /></>,
  instagram: <><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></>,
};

const RIcon = ({ name, width = 20, height = 20, style, className }) => {
  const paths = PATHS[name];
  if (!paths) return null;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.9}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={style}
      className={className}
    >
      {paths}
    </svg>
  );
};

export default RIcon;
